<div #sideNavContainer class="cm-side-nav__container {{ options.panelClass }}">
  <div #sideNavShadow class="cm-side-nav__shadow" (click)="close()"></div>
  <div *ngIf="mobile" #sideNavContent class="cm-side-nav__content {{ 'from-' + from }}">
    <div *ngIf="options?.closeButton" class="cm-side-nav__header">
      <cm-icon-button
        data-cy="sidenav-close-button"
        icon="close"
        aria-hidden="false"
        aria-label="Close side nav"
        (clickEvent)="close()"
      >
      </cm-icon-button>
    </div>
    <ng-content select="#sideNavbody"></ng-content>
  </div>
</div>
